import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Icon, SimpleModal } from '@livable/saas-react-components';
import { Button, Chip } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from 'src/stores';
import FSEBillContent from './FSEBillContent';
import useMoveOutStyles from './../styles';
const FSEBillModal = _ref => {
  let disabled = _ref.disabled,
    disabledRequest = _ref.disabledRequest,
    disabledTrigger = _ref.disabledTrigger,
    isOpen = _ref.isOpen,
    propertyId = _ref.propertyId,
    residencyId = _ref.residencyId,
    residentName = _ref.residentName,
    setFSEBillModalIsOpen = _ref.setFSEBillModalIsOpen,
    submitFSE = _ref.submitFSE,
    triggerType = _ref.triggerType,
    unitName = _ref.unitName,
    parentToggleRefreshCallback = _ref.parentToggleRefreshCallback;
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const moveOutClasses = useMoveOutStyles();
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFetched = _useState2[0],
    setIsFetched = _useState2[1];
  const getTrigger = () => {
    switch (triggerType) {
      case 'actionButton':
        return /*#__PURE__*/React.createElement(Button, {
          variant: "actionButton",
          'custom-attribute': '253-fse-bill-tab'
        }, /*#__PURE__*/React.createElement(Icon, {
          type: "flag"
        }), t('fse_page.view_final_estimation'));
      case 'chip':
        return /*#__PURE__*/React.createElement(Chip, {
          color: "success",
          icon: /*#__PURE__*/React.createElement(Icon, {
            type: "paper-dollar"
          }),
          variant: "portal"
        });
      case 'disabledTrigger':
        return null;
      case 'link':
        return /*#__PURE__*/React.createElement("b", {
          className: "fseLink"
        }, "review final bill");
      default:
        return /*#__PURE__*/React.createElement(Button, {
          size: "small",
          variant: "contained",
          'custom-attribute': '254-fse-bill-tab'
        }, "Review statement");
    }
  };
  const getFinalStatements = async () => {
    const resp = await store.fse.getFinalStatementsAsync.run({
      residencyId
    });
    return resp;
  };
  const getProperty = async data => {
    const resp = await store.properties.getPropertyAsync.run(data);
    return resp;
  };
  const getUtilityInfo = async ids => {
    if (!store.account.featureFlagsStore.getIsBillAutomationEnabled || !store.account.featureFlagsStore.getIsBillingTemplatesEnabled) {
      const resp = await store.utilityProviders.getUtilityInfoAsync.run({
        utilityIds: ids
      });
      return resp;
    } else {
      const resp = await store.utilityProviders.getPropertyUtilityInfoAsync.run({
        utilityIds: ids,
        propertyId
      });
      return resp;
    }
  };
  const getStatemens = () => getFinalStatements().then(() => getUtilityInfo(store.fse.finalStatements.map(item => item.utilityId)));
  const handleSendStatement = async () => {
    try {
      await Promise.resolve(submitFSE === null || submitFSE === void 0 ? void 0 : submitFSE());
    } catch (_unused) {
      return;
    }
    setFSEBillModalIsOpen(false);
  };
  useEffect(() => {
    if (!disabledRequest && !isFetched && isOpen) {
      setIsFetched(true);
      store.fse.setFSEBillModalIsLoadingValue(true);
      getStatemens().then(() => getProperty({
        propertyId: propertyId || store.fse.propertyId
      })).finally(() => {
        setIsFetched(true);
        store.fse.setFSEBillModalIsLoadingValue(false);
      });
    }
    return () => setIsFetched(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);
  return /*#__PURE__*/React.createElement(SimpleModal, {
    disabledTrigger: disabledTrigger,
    handleClose: () => setFSEBillModalIsOpen(false),
    handleOpen: () => setFSEBillModalIsOpen(true),
    isOpen: isOpen,
    headerIcon: "move-out",
    noPadding: true,
    rightButtons: store.company.companyFeatureStore.isAppfolio ? [] : [
    /*#__PURE__*/
    // <Button key="close" variant="text" onClick={() => console.log('Download button clicked')}>
    //   <Icon type="file-download" />
    //   Download statement
    // </Button>,
    React.createElement(Button, {
      disabled: disabled,
      key: "close",
      variant: "contained",
      onClick: handleSendStatement,
      'custom-attribute': '255-fse-bill-tab'
    }, "Send statement")]
    // subTitle="FSE Bill Modal Subtitle"
    ,
    title: "".concat(residentName, " final statement"),
    trigger: getTrigger(),
    variant: "large"
  }, store.company.companyFeatureStore.isAppfolio && /*#__PURE__*/React.createElement("div", {
    className: moveOutClasses.infoBlock
  }, /*#__PURE__*/React.createElement(Chip, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "info"
    }),
    label: "Final batch was automatically generated. Please review AppFolio batches tab.",
    variant: "infoIcon"
  })), /*#__PURE__*/React.createElement(FSEBillContent, {
    isOpen: isOpen,
    residentName: residentName,
    residencyId: residencyId,
    unitName: unitName,
    propertyId: propertyId,
    parentToggleRefreshCallback: parentToggleRefreshCallback
  }));
};
export default FSEBillModal;